<template>
  <nav class="listing-details-nav">
    <h3>Prospectus: {{title}}</h3>

    <div class="grid-wrapper">

      <div class="social-links">
        <v-btn
          class="mx-1 mt-2"
          dark
          fab
          x-small
          elevation="0"
          color="primary"
          href="mailto:listings@successionresourcegroup.com"
          target="_blank">
          <v-icon>mdi-email</v-icon>
        </v-btn>

        <v-btn
          class="mx-1 my-3"
          dark
          fab
          x-small
          elevation="0"
          color="primary"
          @click="$emit('download')">
          <v-icon>mdi-file-download</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          dark
          fab
          x-small
          elevation="0"
          color="primary"
          href="https://www.linkedin.com/company/succession-resource-group/mycompany/"
          target="_blank">
          <v-icon>mdi-linkedin</v-icon>
        </v-btn>
      </div>

      <v-list class="list">
        <v-list-item-group
          :value="current"
          mandatory
        >
        <v-list-item
          v-for="(section, i) in sections"
          :key="i"
          ref="sections"
          :ripple="false"
          @click="updateCurrent(i)"
          style="background-color: #EFEFEF">

          <v-list-item-content>
            <v-list-item-title>
              {{ section.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div ref="slider" class="navigation-slider"></div>

        </v-list-item-group>
      </v-list>
    </div>
  </nav>
</template>

<script>
import debounce from '@/lib/debounce'
import throttle from '@/lib/throttle'

export default {
  name: 'ListingDetailsNavigation',
  props: {
    activeSection: String,
    title: String
  },

  data: () => ({
    current: 0,
    sections: [
      { name: 'content-seller-info', title: 'Seller Information' },
      { name: 'content-company-info', title: 'Company Information' },
      { name: 'content-revenue', title: 'Revenue' },
      { name: 'content-expenses', title: 'Expense Breakdown' },
      { name: 'content-other', title: 'Other Details' },
      // { name: 'content-demographics', title: 'Client Demographic' },
      // { name: 'content-technology', title: 'Technology Use' },
      // { name: 'content-communication', title: 'Communication Methods' },
      { name: 'content-requirements', title: 'Buyer Requirements' },
      { name: 'content-annual-expenses', title: 'Retained Expenses' },
      { name: 'content-terms', title: 'Price & Terms' },
    ],
    allowedHeaderOffset: 150,
  }),

  watch: {
    activeSection (oldVal, newVal) {
      if (oldVal === newVal) return
      this.current = this.sections.findIndex(({ name }) => name === this.activeSection) || 0
    },
  },

  created () {
    this.updateSliderPosition()

    const debouncedEvent = debounce(() => {
      this.updateSliderPosition()
    }, 150, false)
    const throttledEvent = throttle(() => {
      this.setActiveNavItem()
    }, 100)

    this.scrollEvent = () => {
      throttledEvent()
      debouncedEvent()
    }

    window.addEventListener('scroll', this.scrollEvent)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollEvent)
  },

  methods: {
    isOtherSection (index) {
      const otherSections = ['content-demographics', 'content-technology', 'content-communication']
      const { name } = this.sections[index]
      return otherSections.includes(name)
    },

    updateCurrent (current) {
      this.current = current

      this.$emit('update:activeSection', this.sections[this.current].name)
      this.scrollUser()

      if (this.isOtherSection(current)) {
        setTimeout(() => this.updateSliderPosition(), 50)
      }
    },

    setActiveNavItem () {
      const sectionElements = this.sections.map(({ name }) => {
        return document.getElementById(name)
      })

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const element = sectionElements[i]
        if (!element) continue

        const { bottom, top } = element.getBoundingClientRect()

        if (top - this.allowedHeaderOffset < 0) {
          if (this.isOtherSection(i) && !element.classList.contains('v-tab--active')) {
            continue
          }

          this.current = i
          this.updateSliderPosition()
          break
        }
      }
    },

    scrollUser () {
      const el = this.isOtherSection(this.current)
        ? document.getElementById('content-other')
        : document.getElementById(this.sections[this.current].name)

      if (!el) return

      el.scrollIntoView({ behavior: 'smooth' })
    },

    updateSliderPosition () {
      const navEl = ((this.$refs.sections || [])[this.current] || {}).$el
      const sliderEl = this.$refs.slider
      if (!navEl || !sliderEl) return

      sliderEl.style.top = (navEl.offsetTop) + 'px'
      sliderEl.style.height = navEl.offsetHeight + 'px'
    },
  },
}
</script>

<style scoped>
.listing-details-nav {
  position: sticky;
  top: 80px;
  width: 300px;
  margin: 86px auto 0 -20px;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: 40px 1fr;
  /* background-color: #EFEFEF; */
}

.listing-details-nav h3 {
  font-family: "AvenirBook";
  font-size: 18px;
  font-weight: lighter;
  text-transform: uppercase;
}

.list {
  grid-column: 2 / 2;
  padding: 0;
  background-color: #EFEFEF;
}

.v-list-item-group {
  border-left: 5px solid #D9D9D9;
}

.v-list-item__title {
  color: #848484;
  font-family: "Sansation", sans-serif;
}

.v-list-item--active .v-list-item__title {
  background-color: transparent;
  color: #5F6062;
  font-family: "SansationBold", sans-serif;
}

.v-list-item--link::before {
  opacity: 0;
}
.theme--light.v-sheet {
  width: 250px;
  background-color: #EFEFEF;
  /* background: none; */
}
.navigation-slider {
  content: '';
  position: absolute;
  top: 0;
  left: -5px;

  width: 5px;
  background-color: #5F6062;

  transition-property: top, height;
  transition-duration: 0.1s;
}

.social-links {
  width: 35px;
  grid-column: 1 / 2;
}

.social-icon {
  height: 25px;
  width: 25px;
  margin-left: 2.5px;
  margin-top: 2.5px;
}

.social-link {
  height: 30px;
  width: 30px;
  margin: 5px;
  margin-bottom: 15px;
  display: block;
  background: rgb(24,151,166);
  border-radius: 17.5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/Navigation.vue